import { setEnvironmentVaribles } from "./env";
import Vue from "vue";
import Auth from "@aws-amplify/auth";
import { Hub } from "aws-amplify";
import App from "./App.vue";
import awsconfig from "./aws-exports";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";

setEnvironmentVaribles();
awsconfig.cookieStorage = {
  ...awsconfig.cookieStorage,
  ...window.env.CONFIG_COOKIE,
};
const hasCodeInUrl = new URL((window as any).location).searchParams.has("code");
awsconfig.oauth = { ...awsconfig.oauth, ...window.env.OAUTH };
/* eslint-disable @typescript-eslint/camelcase */
const isServiceAccount = isServiceAccountReq(window.location.href);
awsconfig.aws_user_pools_id = isServiceAccount ? window.env.ServiceAccountUserPoolId : window.env.UserPoolId;
awsconfig.aws_user_pools_web_client_id = isServiceAccount ? window.env.ServiceAccountClientId : window.env.ClientId;
if (isServiceAccount){
  awsconfig.oauth.domain = window.env.ServiceAccountOAUTHdomain;
  window.env.OAUTH.domain = window.env.ServiceAccountOAUTHdomain
}
/* eslint-enable @typescript-eslint/camelcase */
Hub.listen("auth", (data: any) => {
  if (data.payload.event === "signIn" && hasCodeInUrl) {
    redirect();
  }
});
Auth.configure(awsconfig);
Vue.config.productionTip = false;

function getRedirectUri() {
  const params = new URL(window.location.href).searchParams;
  const urlRedirect = params.get("redirect_uri");
  const sessionRedirect = sessionStorage.getItem("redirect_uri");
  return urlRedirect || sessionRedirect || window.env.DEFAULT_REDIRECT || "";
}

function redirect() {
  location.href = getRedirectUri();
}

function isServiceAccountReq(href:string) {
    const redirectStr = "?redirect_uri=";
    const idx = href.indexOf(redirectStr);
    const extractUrl = (idx > 0) ? href.substring(idx+redirectStr.length) : window.location.href;
    const searchParams = new URLSearchParams((new URL(extractUrl)).search);
    const accountType = searchParams.get("accountType");
    return accountType === "serviceAccount";
}

async function isLoggedIn() {
  try {
    await Auth.currentAuthenticatedUser();
    await Auth.currentSession();
  } catch (e) {
    console.error(e); /* eslint-disable-line no-console */
    return false;
  }
  return true;
}

const startup = async () => {
  sessionStorage.setItem("redirect_uri", getRedirectUri());
  const loggedIn = await isLoggedIn();
  if (loggedIn) {
    redirect();
  } else if (!hasCodeInUrl) {
    new Vue({
      vuetify,
      i18n,
      render: h => h(App, { props: { redirect } }),
    }).$mount("#app");
  }
};

startup();
